
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
    props: {
        isActive: { type: Boolean, required: true },
        fill: { type: String, default: 'currentColor' }
    }
})
